// Opening move: Shared canonical lyrics constant for deterministic testing
// This constant is used by both the React hook and E2E test utilities
// Source of truth: frontend/fixtures/lyrics/canon-demo.txt

/**
 * CANONICAL_LYRICS_TEXT - Standardized test lyrics
 *
 * Main play: Single source of truth for canonical lyrics used across:
 * - useCanonicalLyrics React hook (browser context)
 * - E2E test fixtures (Node.js context via lyricsFixtures.ts)
 * - Manual QA and demo scenarios
 *
 * IMPORTANT: This must match frontend/fixtures/lyrics/canon-demo.txt exactly
 * The fixture file is loaded by E2E tests using fs.readFileSync, while this
 * constant is used by the React hook in browser context where fs is unavailable
 */
export const CANONICAL_LYRICS_TEXT = `[Verse 1]
Softly we sing in the valley tonight
Echoes of dreams under pale silver light

[Chorus]
Carry the rhythm, carry it far
Hearts keeping time like a lantern star`

// Victory lap: Shared constant ensures consistency across test environments
